<template>
    <v-app>



        <Drawer current_item="menu_staff"></Drawer>

        <v-dialog v-model="dialog_add_staff" max-width="600">
            <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
                {{ $t('add_staff') }} : {{ $t('staff_role_' + new_staff_type) }} 
            </v-card-title>
            <v-card-text>

                <div class="subtitle-2 mt-6" align="left"><b>{{ $t('staff_displayname') }}</b></div>
                <v-text-field v-model="new_staff_displayname" dense outlined solo class="mt-1" :label="$t('staff_displayname')"></v-text-field>

                <div class="subtitle-2" align="left"><b>{{ $t('username') }}</b></div>
                <v-text-field v-model="new_staff_username" dense outlined solo class="mt-1" :label="$t('username')"></v-text-field>

                <div class="subtitle-2" align="left"><b>{{ $t('password') }}</b></div>
                <v-text-field v-model="new_staff_password" dense outlined solo class="mt-1" :label="$t('password')"></v-text-field>
                <v-text-field v-model="new_staff_repassword" dense outlined solo class="mt-n4" :label="$t('repassword')"></v-text-field>
                
                <div class="subtitle-2 mb-1" align="left"><b>{{ $t('station') }}</b></div>
                <FragmentSelectStation @onchange="onStationChange" :have_label="false"></FragmentSelectStation>

                <FragmentSelectGroup 
                    v-if="new_staff_type==4"
                    @ongroup="onGroup" 
                    :station_code="new_staff_station.station_code" 
                    :multiple="true"
                    :have_group_0="false"
                    ref="group" 
                ></FragmentSelectGroup>


            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="addStaff" :disabled="!new_staff_ready">{{ $t('form_submit') }}</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
        v-model="dialog_action_confirm"
        persistent
        scrollable
        max-width="600"
      >
          <v-card>
              <v-card-title>
                  กรุณายืนยันที่จะลบเจ้าหน้าที่ {{ del_staff.displayname }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialog_action_confirm=false"
                >
                  ยกเลิก
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="dialog_action_confirm=false;delStaff();"
                >
                  ยืนยัน
                </v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>

        <v-main class="ml-6 mr-6">

            <v-card
              class="mx-auto mt-4 mr-6 pa-6"
              outlined
              elevation=8
              v-if="permission.includes('VIEW_admin_list')"
            >
                <v-row align="end" justify="space-between">
                <v-col cols="12" md="9" class="text-h5" align="left">
                    {{ $t('staff_list') }} : {{ $t('staff_role_1') }}
                    </v-col>
                </v-row>

                <v-simple-table fixed-header align="left" >
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left">#{{ $t('staff_code') }}</th>
                        <th class="text-left">{{ $t('staff_displayname') }}</th>
                        <th class="text-left">อีเมล</th>
                        <th class="text-left">{{ $t('station') }}</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr v-for="item in adminlist" :key="item.staff_code" v-on:click="onclickstaff(item.staff_id)">
                            <td>{{ item.staff_code }}</td>
                            <td>{{ item.displayname }}</td>
                            <td>{{ item.email }}</td>
                            <td>{{ item.station_list_text }}</td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
            </v-card>

            <v-card
              class="mx-auto mt-4 mr-6 pa-6"
              outlined
              elevation=8
              v-if="permission.includes('VIEW_creator_list')"
            >
                <v-row align="end" justify="space-between">
                <v-col cols="12" md="9" class="text-h5" align="left">
                    {{ $t('staff_list') }} : {{ $t('staff_role_2') }}
                    </v-col>
                <v-col cols="12" md="3" align="left">
                    <v-btn v-if="permission.includes('CREATE_creator_list')" tile style="color:white" color="blue" @click="openAddStaffDialog(2)">
                        <v-icon left>mdi-plus</v-icon>{{ $t('add_staff') }}
                    </v-btn>
                </v-col>
                </v-row>

                <v-simple-table fixed-header align="left" >
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left">#{{ $t('staff_code') }}</th>
                        <th class="text-left">{{ $t('staff_displayname') }}</th>
                        <th class="text-left">อีเมล</th>
                        <th class="text-left">{{ $t('station') }}</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr v-for="item in creatorlist" :key="item.staff_code" v-on:click="onclickstaff(item.staff_id)">
                            <td>{{ item.staff_code }}</td>
                            <td>{{ item.displayname }}</td>
                            <td>{{ item.email }}</td>
                            <td>{{ item.station_list_text }}</td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
            </v-card>

            <v-card
              class="mx-auto mt-4 mr-6 pa-6"
              outlined
              elevation=8
              v-if="permission.includes('VIEW_supervisor_list')"
            >
                <v-row align="end" justify="space-between">
                <v-col cols="12" md="9" class="text-h5" align="left">
                    {{ $t('staff_list') }} : {{ $t('staff_role_3') }}
                    </v-col>
                <v-col cols="12" md="3" align="left">
                    <v-btn v-if="permission.includes('CREATE_supervisor_list')" tile style="color:white" color="blue" @click="openAddStaffDialog(3)">
                        <v-icon left>mdi-plus</v-icon>{{ $t('add_staff') }}
                    </v-btn>
                </v-col>
                </v-row>

                <v-simple-table fixed-header align="left" >
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left">#{{ $t('staff_code') }}</th>
                        <th class="text-left">{{ $t('staff_displayname') }}</th>
                        <th class="text-left">อีเมล</th>
                        <th class="text-left">{{ $t('station') }}</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr v-for="item in supervisorlist" :key="item.staff_code" v-on:click="onclickstaff(item.staff_id)">
                            <td>{{ item.staff_code }}</td>
                            <td>{{ item.displayname }}</td>
                            <td>{{ item.email }}</td>
                            <td>{{ item.station_list_text }}</td>
                            <td v-if="permission.includes('DELETE_supervisor_list') && item.username != username">
                                <v-btn tile icon @click="dialogDelstaff(item)">
                                <v-icon>mdi-trash-can</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
            </v-card>

            <v-card
              class="mx-auto mt-4 mr-6 pa-6"
              outlined
              elevation=8
              v-if="permission.includes('VIEW_viewer_list')"
            >
                <v-row align="end" justify="space-between">
                <v-col cols="12" md="9" class="text-h5" align="left">
                    {{ $t('staff_list') }} : {{ $t('staff_role_4') }}
                    </v-col>
                <v-col cols="12" md="3" align="left">
                    <v-btn v-if="permission.includes('CREATE_viewer_list')" tile style="color:white" color="blue" @click="openAddStaffDialog(4)">
                        <v-icon left>mdi-plus</v-icon>{{ $t('add_staff') }}
                    </v-btn>
                </v-col>
                </v-row>

                <v-simple-table fixed-header align="left" >
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left">#{{ $t('staff_code') }}</th>
                        <th class="text-left">{{ $t('staff_displayname') }}</th>
                        <th class="text-left">อีเมล</th>
                        <th class="text-left">{{ $t('station') }}</th>
                        <th class="text-left">{{ $t('group') }}</th>
                        <th></th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr v-for="item in viewerlist" :key="item.staff_code" v-on:click="onclickstaff(item.staff_id)">
                            <td>{{ item.staff_code }}</td>
                            <td>{{ item.displayname }}</td>
                            <td>{{ item.email }}</td>
                            <td>{{ item.station_list_text }}</td>
                            <td>  
                                <ul>
                                    <li v-for="item in item.group_list_text" :key="item">
                                        {{ item }}
                                    </li>
                                </ul>
                            </td>
                            <td v-if="permission.includes('DELETE_viewer_list') && item.username != username">
                                <v-btn tile icon @click="dialogDelstaff(item)">
                                <v-icon>mdi-trash-can</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
            </v-card>

        </v-main>
    </v-app>
</template>


<script>
import Drawer from '@/components/Drawer.vue'

import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

import FragmentSelectStation from '@/components/Common/FragmentSelectStation.vue'
import FragmentSelectGroup from '@/components/Common/FragmentSelectGroup.vue'

export default {
  components: {
    Drawer
    ,FragmentSelectStation
    ,FragmentSelectGroup
  },
  data () {
    return {
        adminlist : []
        ,creatorlist : []
        ,supervisorlist : []
        ,viewerlist : []
        
        ,dialog_add_staff : false
        ,new_staff_type : -1
        ,new_staff_displayname : ""
        ,new_staff_username : ""
        ,new_staff_password : ""
        ,new_staff_repassword : ""
        ,new_staff_station : {}
        ,new_staff_grouplist : []

        ,permission : []

        ,dialog_action_confirm : false
        ,del_staff : {displayname:""}

        ,username : ''
    }
  },
  computed : {
    new_staff_ready(){
        return this.new_staff_type > 0 
            && this.new_staff_displayname.length > 0
            && this.new_staff_username.length > 0
            && this.new_staff_password.length > 0
            && this.new_staff_password == this.new_staff_repassword 
            && this.new_staff_station.station_code != undefined
    }
  },
  mounted : function () {
    this.username = Staff.getUsername()
    var que = this.$store.commit('addLoading')
    this.permission = Staff.getPermission('Staff').then(permission=>{
        this.permission = permission
        this.$store.commit('finishLoading',que)
    })
    this.$store.getters.getStationList
    .then(result=>{
        this.select_station_items = result
    }).catch(error => {
        this.$router.push({name:'Error',params:error}) 
    })

    this.reload()
  },
  methods : {
    onclickstaff(staff_id){
        this.$router.push({name:'StaffDetail',params:{staff_id:staff_id}})
    },
    reload(){
        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.manage.staff.get_stafflist,{},{ headers: Staff.getTokenHeader()}
        ).then(response => {
            Object.keys(response.data).forEach(key=>{
                response.data[key].forEach((r,i)=>{

                    response.data[key][i].station_list_text = 
                        response.data[key][i].station_list.filter(s=>s!=null)[0]
                        + (response.data[key][i].station_list.length > 1 ? ' และอีก ' + (response.data[key][i].station_list.length-1) : '')
                
                    if(response.data[key][i].group_list != undefined){
                        var group_count = response.data[key][i].group_list.length
                        if(group_count>5){group_count = 5}
                        var group_list = []
                        var filter_group_list = response.data[key][i].group_list.filter(g=>g!=null)
                        for(var j=0;j<group_count;j++){
                            group_list.push(filter_group_list[j])
                        }
                        if(response.data[key][i].group_list.length>5){
                            group_list.push("และอีก " + (response.data[key][i].group_list.length-5))
                        }
                        response.data[key][i].group_list_text = group_list
                    }

                })
            })

            this.adminlist = response.data.adminlist
            this.creatorlist = response.data.creatorlist
            this.supervisorlist = response.data.supervisorlist
            this.viewerlist = response.data.viewerlist

            this.$store.commit('finishLoading',que)
        })
        .catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
    },
    openAddStaffDialog(staff_type){
        this.dialog_add_staff = true
        this.new_staff_type = staff_type
    },
    dialogDelstaff(staff){
        this.dialog_action_confirm = true
        this.del_staff = staff
    },
    delStaff(){
        var staff = this.del_staff
        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.manage.staff.del_staff,{
            staff_code:staff.staff_code
            ,staff_type:4
        },{ headers: Staff.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.reload()
        })
        .catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
    },
    addStaff(){

        var reqdata = {
            displayname:this.new_staff_displayname
            ,username:this.new_staff_username
            ,password:this.new_staff_password
            ,station_code:this.new_staff_station.station_code
            ,staff_type:this.new_staff_type
        }

        if(this.new_staff_type!=4 || this.new_staff_grouplist==undefined || this.new_staff_grouplist.length==0){console.log('hello')}
        else{
            reqdata['group_id_list'] = this.new_staff_grouplist.map(gr=>gr.group_id)
        }

        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.manage.staff.add_staff,reqdata,{ headers: Staff.getTokenHeader()}
        ).then(() => {
            this.$store.commit('finishLoading',que)
            this.dialog_add_staff = false
            this.new_staff_type = -1
            this.new_staff_displayname = ""
            this.new_staff_username = ""
            this.new_staff_password = ""
            this.new_staff_repassword = ""
            this.reload()
        })
        .catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
    },
    onStationChange(station){
        this.new_staff_station = station
        this.$refs.group.reload()
    },
    onGroup(grouplist){
        this.new_staff_grouplist = grouplist
    }
  }
}
</script>